// removed by extract-text-webpack-plugin
module.exports = {"title":"cc_n","list":"cc_ce _3JIEYde9anI6O5H5wYv2ik"};


//////////////////
// WEBPACK FOOTER
// ./app/src/components/Footer/components/FooterNav/styles.module.css
// module id = 1055
// module chunks = 27